import React from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/nav/shared/NavLink';
import connectStore from 'decorators/connectStore';
import VerifiedProfileStore from 'stores/VerifiedProfileStore';
import VerifiedProfileActionCreator from 'actions/VerifiedProfileActionCreator';
import WeblabHelper from '../../../utils/WeblabHelper';

@connectStore(VerifiedProfileStore, 'verifiedProfileState')
class PrimaryItems extends React.Component {
  static propTypes = {
    verifiedProfileState: PropTypes.shape({
      accountPool: PropTypes.shape({
        accountPoolName: PropTypes.string,
      }).isRequired,
    }),
  };

  componentDidMount() {
    VerifiedProfileActionCreator.fetchAccountPool();
  }

  render() {
    const showContributionsTab = WeblabHelper.getWeblabsMap().AUTHOR_PROMPT_404592;
    const contributionsTab = showContributionsTab
      ? <li><NavLink to="/contributions" type="Link" stringID="AA_Contributions" /></li> : null;
    return (
      <ul className="nav navbar-nav">
        <li><NavLink to="/home" type="Link" stringID="AA_Home" /></li>
        <li><NavLink to="/profile" type="Link" stringID="AA_AuthorPage" /></li>
        <li><NavLink to="/books" type="Link" stringID="AA_Books" /></li>
        <li><NavLink to="/marketingAndReports" type="Link" stringID="AA_Marketing_Reports_Heading" /></li>
        {contributionsTab}
      </ul>
    );
  }
}

export default PrimaryItems;
